import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Dashboard from "../views/Home/Dashboard.vue";
import Notifications from "../views/Home/Notifications.vue";
import Files from "../views/Home/Files/index.vue";
import FilesNew from "../views/Home/Files/new.vue";
import Users from "../views/Home/Users/index.vue";
import UsersNew from "../views/Home/Users/new.vue";
import Sections from "../views/Home/Sections/index.vue";
import SectionsNew from "../views/Home/Sections/new.vue";
import Languages from "../views/Home/Language/index.vue";
import ContactUs from "../views/Home/ContactUs/index.vue";
import Subscribers from "../views/Home/Subscribers/index.vue";
import Achievements from "../views/Home/Achievements/index.vue";
import AchievementsNew from "../views/Home/Achievements/new.vue";
import Values from "../views/Home/Values/index.vue";
import ValuesNew from "../views/Home/Values/new.vue";
import Partners from "../views/Home/Partners/index.vue";
import PartnersNew from "../views/Home/Partners/new.vue";
import Staff from "../views/Home/Staff/index.vue";
import StaffNew from "../views/Home/Staff/new.vue";
import Contributors from "../views/Home/Contributors/index.vue";
import ContributorsNew from "../views/Home/Contributors/new.vue";
import PostsCats from "../views/Home/Posts/categories.vue";
import Posts from "../views/Home/Posts/index.vue";
import PostsNew from "../views/Home/Posts/new.vue";
import Categories from "../views/Home/Categories/index.vue";
import CategoriesNew from "../views/Home/Categories/new.vue";
import Forms from "../views/Home/Forms/index.vue";
import FormsNew from "../views/Home/Forms/new.vue";
import SubmissionCats from "../views/Home/Submissions/categories.vue";
import Submissions from "../views/Home/Submissions/index.vue";
import SubmissionsList from "../views/Home/Submissions/submissions.vue";
import Settings from "../views/Home/Settings/index.vue";
// import Purchases from "../views/Home/Purchases/index.vue";
// import PurchasesNew from "../views/Home/Purchases/new.vue";
// import Mixing from "../views/Home/Mixing/index.vue";
// import MixingNew from "../views/Home/Mixing/new.vue";
// import Entry from "../views/Home/Entry/index.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        alias: "/",
        name: "Login",
        component: Login,
    },
    {
        path: "/home",
        name: "Home",
        component: Home,
        children: [
            {
                path: "dashboard",
                alias: "/",
                name: "Dashboard",
                component: Dashboard,
            },
            {
                path: "notifications",
                name: "Notifications",
                component: Notifications,
            },
            {
                path: "files",
                name: "Files",
                component: Files,
            },
            {
                path: "files/:id",
                name: "Files New/Edit",
                component: FilesNew,
            },
            {
                path: "users",
                name: "User",
                component: Users,
            },
            {
                path: "users/:id",
                name: "User New/Edit",
                component: UsersNew,
            },
            {
                path: "sections",
                name: "Section",
                component: Sections,
            },
            {
                path: "sections/:id",
                name: "Section New/Edit",
                component: SectionsNew,
            },
            {
                path: "languages",
                name: "Language",
                component: Languages,
            },
            {
                path: "contactus",
                name: "ContactUs",
                component: ContactUs,
            },
            {
                path: "subscribers",
                name: "Subscribers",
                component: Subscribers,
            },
            {
                path: "achievements",
                name: "Achievement",
                component: Achievements,
            },
            {
                path: "achievements/:id",
                name: "Achievement New/Edit",
                component: AchievementsNew,
            },
            {
                path: "values",
                name: "Value",
                component: Values,
            },
            {
                path: "values/:id",
                name: "Value New/Edit",
                component: ValuesNew,
            },
            {
                path: "partners",
                name: "Partner",
                component: Partners,
            },
            {
                path: "partners/:id",
                name: "Partner New/Edit",
                component: PartnersNew,
            },
            {
                path: "staff",
                name: "Staff",
                component: Staff,
            },
            {
                path: "staff/:id",
                name: "Staff New/Edit",
                component: StaffNew,
            },
            {
                path: "contributors",
                name: "Contributors",
                component: Contributors,
            },
            {
                path: "contributors/:id",
                name: "Contributors New/Edit",
                component: ContributorsNew,
            },
            {
                path: "posts",
                name: "Post",
                component: PostsCats,
            },
            {
                path: "posts/:cat",
                name: "Posts",
                component: Posts,
            },
            {
                path: "posts/:cat/:id",
                name: "Post New/Edit",
                component: PostsNew,
            },
            {
                path: "categories",
                name: "Category",
                component: Categories,
            },
            {
                path: "categories/:id",
                name: "Category New/Edit",
                component: CategoriesNew,
            },
            {
                path: "forms",
                name: "Form",
                component: Forms,
            },
            {
                path: "forms/:id",
                name: "Form New/Edit",
                component: FormsNew,
            },
            {
                path: "submissions",
                name: "Submission Cats",
                component: SubmissionCats,
            },
            {
                path: "submissions/:cat",
                name: "Submission",
                component: Submissions,
            },
            {
                path: "submissions/:cat/:id",
                name: "Submission List",
                component: SubmissionsList,
            },
            {
                path: "settings",
                name: "Settings",
                component: Settings,
            },
            // {
            //     path: "purchases",
            //     name: "Purchase",
            //     component: Purchases
            // },
            // {
            //     path: "purchases/:id",
            //     name: "Purchase New/Edit",
            //     component: PurchasesNew
            // },
            // {
            //     path: "mixing",
            //     name: "Minxing",
            //     component: Mixing
            // },
            // {
            //     path: "mixing/:id",
            //     name: "Minxing New/Edit",
            //     component: MixingNew
            // },
            // {
            //     path: "entries",
            //     name: "entries New/Edit",
            //     component: Entry
            // }
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    linkActiveClass: "is-active",
    base: process.env.BASE_URL,
    routes,
});

export default router;
